//
// 工具方法
// ============================================================

let evDate = [];
let Ns = class {
    constructor(option) {
        if (!option) return;

        this.result;

        if (option.nodeType == 1 || option.nodeType == 9){
            this.element = [option];
        }else if (typeof option == "string"){
            return this.getEl(option);
        }else {
            return this.init(option);
        }

    }

    init(option) {
        if (typeof option.el == "string"){
            this.getEl(option.el);
            if (option.eventHandle) {
                this.addEv(option.el, option.eventHandle)
            }
            if (option.load) {
                this.load(option.load)
            }
        }

        if (option.callback) {
            this.callback(option.callback)
        }
    }

    getEl(el) {
        let selector = document.querySelector(el) ? document.querySelectorAll(el) : "";
        this.element = this.selector = selector;
        return this;
    }

    load(callback) {
        this.each(this.selector, item => {
            let result = callback.call(item);
            if (result != undefined) {
                this.result = result;
            }
        });
    }

    callback(callback) {
        return callback();
    }

    eq(i) {
        if(!this.element) return this;
        if(i == "-1") {
            this.element = [this.element.length-1];
        }else {
            this.element = [this.element[i]]
        }
        return this;
    }

    get(i) {
        if(i == "-1" || i > this.element.length) {
            return this.element[this.element.length-1]
        }else {
            return i != undefined ? this.element[i] : this.element
        }
    }

    length() {
        return this.element.length;
    }

    addEv(el, eventHandle) {
        let handle = (obj) => {
            let type = obj.type,
                callback = obj.callback,
                entrust = obj.entrust ? obj.entrust : el,
                newCallback, targetParents, target, bool = true;

            newCallback = ev => {
                target = ev.target;
                targetParents = this.targetParents(target, entrust, el);
                if(targetParents == undefined) return;

                if (entrust == el) {
                    this.each(this.selector, selector => {
                        if (targetParents.parent && [targetParents.parent].indexOf(selector) != "-1" && bool) {
                            bool = false;
                            this.element = [selector];
                            let result = callback.call(selector, ev = ev);
                            if (result != undefined) {
                                bool = true;
                                this.result = result;
                            }
                        }
                    })
                } else if (entrust != "" && targetParents.self && bool) {
                    bool= false;
                    this.element = [targetParents.self];
                    let result = callback.call(targetParents.self, ev = ev);
                    if (result != undefined) {
                        bool = true;
                        this.result = result;
                    }
                }

            };

            evDate.push({
                entrust: entrust,
                type: type,
                callback: newCallback,
                originFn: callback
            })
        };

        if(eventHandle.length > 0) {
            this.each(eventHandle, item => {
                handle(item);
            });
        }else {
            handle(eventHandle);
        }

        this.off();
        return this.on();
    }

    on(entrust, type, callback) {
        this.each(evDate, item => {
            if (!entrust && !type && !callback) {
                document.addEventListener(item.type, item.callback, false);
            }

            if (entrust== item.entrust && type == item.type && callback == item.originFn) {
                document.addEventListener(item.type, item.callback, false);
            }
        });

        return this;
    }

    off(entrust, type, callback) {
        this.each(evDate, item => {
            if (!entrust && !type && !callback) {
                document.removeEventListener(item.type, item.callback)
            }

            if (entrust == item.entrust && type == item.type && callback == item.originFn) {
                document.removeEventListener(item.type, item.callback);
            }
        });

        return this;
    }

    each(obj, callback, isSequence) {
        return Ns.each(obj, callback, isSequence)
    }

    find(children) {
        let result = [];
        this.each(this.element, item => {
            result.push(...item.querySelectorAll(children));
        });
        // this.element = [];
        this.element = result;
        return this;
    }

    prev() {
        let result = [];

        this.each(this.element, item => {
            if (item.previousElementSibling != null){
                result.push(item.previousElementSibling);
            }
        });

        this.element = [];
        this.element = result;

        return this;
    }

    next() {
        let result = [];

        this.each(this.element, item => {
            if (item.nextElementSibling != null){
                result.push(item.nextElementSibling);
            }
        });

        this.element = [];
        this.element = result;

        return this;
    }

    parent() {
        let parentNode = this.element[0].parentNode;
        this.element = [];
        this.element = [parentNode];
        return this;
    }

    targetParents(target, selector, parent) {
        let result = {};
        let element = target;

        let verify = str => {
            if(element == document || !str) return false;
            let isId = str.indexOf("#") != "-1" && element.id && element.id.indexOf(str.replace(/^\#/, "")) != "-1";

            let isClass = str.indexOf(".") != "-1" && element.className && element.className.split(" ").indexOf(str.replace(/^\./, "" )) != "-1";

            let isTagName = element.tagName && element.tagName.toLocaleLowerCase() == str;

            return isId || isClass || isTagName
        };

        while (element) {

            let bool = verify(selector);

            if(verify(selector) ) {
                result.self = element;
            }
            if (verify(parent)) {
                result.parent = element;
                break;
            }
            if (element == document) {
                result = document;
                break;
            }
            element = element.parentNode;
        }

        // result.self = !result.self ? result.parent : result.self;
        if (result && result != document && result != undefined) return result
    }

    parents(selector) {
        let result = [];
        let element = this.element[0].parentNode;
        while (element) {
            if (selector.nodeType == 1) {
                if(element == selector){
                    result = [element];
                    break
                }
            }
            if (typeof selector == "string"){

                let isId = selector.indexOf("#") != "-1" && element.id && element.id.indexOf(selector.replace(/^\#/, "")) != "-1";

                let isClass = selector.indexOf(".") != "-1" && element.className && element.className.indexOf(selector.replace(/^\./, "" )) != "-1";

                let isTagName = element.tagName && element.tagName.toLocaleLowerCase() == selector;

                if (isId || isClass || isTagName) {
                    result = [element];
                    this.element = result;
                    break
                }
            }
            element = element.parentNode;
            result.push(element);
        }

        this.element = result;
        return this;
    }

    children(selector) {
        let result= [];
        this.each(this.element, item => {
            let childrens = item.children;
            result.push(...childrens);
        });
        this.element = result;
        return this;
    }

    hasClass(el, cls) {
        if (!cls) {
            cls = el;
            if (cls.replace(/\s/g, '').length == 0) return false;
            let result;

            this.each(this.element, item => {
                let itemClassName = item.className;
                if(itemClassName != "") {
                    result = itemClassName.split(" ").indexOf(cls) != "-1"
                }
            });
            return result;

        }else {
            if (cls.replace(/\s/g, '').length == 0) return false;
            return new RegExp(' ' + cls + ' ').test(' ' + el.className + ' ');
        }
        ns(this).parents(".tree-wrapper")
    }

    addClass(cls) {

        this.each(this.element, item => {
            if (!this.hasClass(item, cls)) {
                item.className = item.className == '' ? cls : item.className + ' ' + cls;
            }
        });
        return this;
    }

    removeClass(cls) {

        this.each(this.element, item => {
            if (this.hasClass(item, cls)) {
                let newClass = ' ' + item.className.replace(/[\t\r\n]/g, '') + ' ';
                while (newClass.indexOf(' ' + cls + ' ') >= 0) {
                    newClass = newClass.replace(' ' + cls + ' ', ' ');
                }
                item.className = newClass.replace(/^\s+|\s+$/g, '');
            }
        });
        return this;
    }
    toggleClass (cls) {

        this.each(this.element, item => {
            if (this.hasClass(item, cls)) {
                this.removeClass(cls);
            }else{
                this.addClass(cls);
            }
        });
        return this;
    }

    attr (name, val) {
        if (val === undefined){
            if (this.element.length == 1) {
                return this.element[0].getAttribute(name)
            }else if(this.element.length >= 2) {
                let result = [];
                this.each(this.element, item => {
                    result.push(item.getAttribute(name))
                });
                return result;
            }else {
                return undefined
            }
        }else {

            this.each(this.element, item => {
                item.setAttribute(name, val)
            })
        }
        return this;
    }

    removeAttr (name) {
        if (name !== undefined){

            this.each(this.element, item => {
                item.removeAttribute(name)
            });
        }
    }

    css(styleName, styleValue, isCss3) {
        this.each(this.element, item => {
            if (typeof styleName == "object") {
                isCss3 = styleValue ? true: false;
                this.each(styleName, (key, val) => {

                    if(isCss3) {
                        let styleName2 = key.replace(key.charAt(0), key.charAt(0).toUpperCase());
                        item.style["Webkit"+styleName2] = val;
                        item.style["Moz"+styleName2] = val;
                        item.style["Ms"+styleName2] = val;
                        item.style[key] = val;
                    }else {
                        item.style[key] = val;
                    }
                })
            }else if(styleName && styleValue){
                isCss3 = isCss3 ? true: false;
                if(isCss3) {
                    let styleName2 = styleName.replace(styleName.charAt(0), styleName.charAt(0).toUpperCase());
                    item.style["Webkit"+styleName2] = styleValue;
                    item.style["Moz"+styleName2] = styleValue;
                    item.style["Ms"+styleName2] = styleValue;
                    item.style[styleName] = styleValue;
                }else {
                    item.style[styleName] = styleValue;
                }
            }
        });
        return this;
    }

    getStyle(styleName) {
        let result= [];
        this.each(this.element, item => {

            let styleValue = item.currentStyle ? item.currentStyle[styleName] : getComputedStyle(item,false)[styleName];
            styleValue.indexOf("px") != "-1" ? result.push(parseFloat(styleValue)) : result.push(styleValue)
        });

        return result.length == 1 ? result[0] : result;

    }

    val (val) {
        if (val === undefined){
            return this.element.length > 0 ? this.element[0].value : undefined;
        }else {

            this.each(this.element, item => {
                item.value = val;
            });
        }
        return this;
    }

    text (text) {
        if (!text){
            return this.element.length >= 1 ? this.element[0].innerText : undefined;
        }else {

            this.each(this.element, item => {
                item.innerText = text;
            });
        }

        return this;
    }

    html (html) {
        html = html.trim("");
        if (!html) {
            return this.element.length >= 1 ? this.element[0].innerHTML : undefined;
        }else {

            this.each(this.element, item => {
                if (typeof html == "string") {
                    if ((html.startsWith("<") && html.endsWith(">") && html.length >= 3) || html == ""){
                        item.innerHTML = html;
                    }else{
                        this.text(html)
                    }
                }

            });
        }

        return this;
    }

    before (html) {
        if (this.isHtml(html)){
            let h = this.parseHtml(html);

            this.each(this.element, (item, i) => {

                this.each(h, node => {
                    let aNode = i === 0 ? node : node.cloneNode(true);
                    item.parentNode.insertBefore(aNode, item);
                });
            });
        }
    }

    after (html) {
        if (this.isHtml(html)){
            let h = this.parseHtml(html);

            this.each(this.element, (item, i) => {
                this.each(h, node => {
                    let aNode = i === 0 ? node : node.cloneNode(true);
                    item.parentNode.insertBefore(aNode, item.nextElementSibling);
                });
            });
        }
    }

    append (html) {
        if (!html) return;
        if (this.isHtml(html)){
            let h = this.parseHtml(html);

            this.each(this.element, (item, i) => {
                this.each(h, node => {
                    let aNode = i === 0 ? node : node.cloneNode(true);
                    item.appendChild(aNode);
                });
            });
        }
    }

    remove() {
        this.each(this.element, item => {
            if (item && item.parentNode){
                item.parentNode.removeChild(item);
            }
        });
    }


    isHtml (html) {
        html = html.trim("");
        if (html.startsWith("<") && html.endsWith(">") && html.length >= 3) return true;
    }

    parseHtml (html) {
        if (typeof html == 'object'){
            html = html.innerHTML;
        }

        let div = document.createElement('div'), result = [];
        div.innerHTML = html;

        this.each(div.childNodes, item => {
            if (item.nodeType == 1){
                result.push(item);
            }
        });
        return result;
    }

    static err(options) {
        let verifyType = (obj, type) => {
            let typeArr = type.trim(" ").match(/\S+/g);
            let result= [];
            if (typeArr.length > 1) {
                this.each(typeArr, type => {
                    let isBool = typeof obj == type;
                    result.push(isBool);
                }, true);
            }else {
                let isBool = typeof obj == typeArr[0];
                result.push(isBool);
            }

            return result;
        };

        let errHint = (name, value, type) => {
            try {
                throw new Error('启禀殿下，臣发现您在 '+ options.method +' 方法定义的属性 "'+ name + " : " + value +'" ,其值非指定 ' + type + ' 类型ヽ(●-`Д´-)ノ');
            }catch(ev) {
                console.error(ev.stack);
            }
        };

        let isErr;
        this.each(options.arg, item => {
            if(typeof item.value == "string"){
                if (item.isNull && !item.value) return;
                if (!item.isNull && !item.value) return errHint(item.name[i], values, item.typeof);

                let result = verifyType(item.value, item.typeof);
                if(result.indexOf(true) == "-1"){
                    errHint(item.name, item.value, item.typeof);
                    isErr = "err";
                }
            }else {
                this.each(item.value, (values, i)=> {
                    if (item.isNull && !values) return;
                    if (!item.isNull && !item.value) return errHint(item.name[i], values, item.typeof);

                    let result = verifyType(values, item.typeof);
                    if(result.indexOf(true) == "-1"){
                        errHint(item.name[i], values, item.typeof);
                        isErr = "err";
                    }
                })
            }
        });

        return isErr;
    }

    static each(obj, callback, isSequence) {
        if (!obj || !callback) return;
        if (typeof obj === "object"  && !obj.length) {
            for (let i in obj) {
                let result = callback.call( obj[i], i, obj[i]);
                if (result === false) break;
            }
        }else {
            let isNumber = typeof obj == "number";
            if (isSequence == true) {
                for( let i = 0, len = isNumber ?  obj : obj.length; i < len; i++) {
                    let result = isNumber ? callback.call( "", i, i) : callback.call( obj[i], obj[i], i);
                    if (result === false) break;
                }
            }else {
                for( let i =  isNumber ?  obj-1 : obj.length-1; i >= 0; i--) {
                    let result = isNumber ? callback.call( "", i, i) : callback.call( obj[i], obj[i], i);
                    if (result === false) break;
                }
            }
        }
    }
};

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    window.Ns = Ns;
    window.ns = option => new Ns(option);
    module.exports =  Ns;
}
else {
    if (typeof define === 'function' && define.amd) {
        define([], function() {
            return v;
        });
    }
}





// WEBPACK FOOTER //
// src/js/utility.js